(() => {
  if (customElements.get('mvh-restock')) return;
  class Restock extends HTMLElement {
    connectedCallback() {
      this.host = this.dataset.standalone === 'true' ? this : this.closest('featured-product');
      if (!this.host) return;
      try {
        this.product = JSON.parse((this.querySelector('[data-mvh-restock-product-json]') || this.host.querySelector('[data-product-json]')).textContent);
      } catch { return; }
      this.form = this.querySelector('form');
      this.message = this.querySelector('[role=status]');
      this.button = this.querySelector('button');
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.buttonLabel = this.button.textContent;
      this.summaryLabel = this.summary?.textContent;
      this.message.setAttribute('tabindex', '-1');
      this.message.setAttribute('aria-atomic', 'true');
      this.variant = this.product.variants.find(v => String(v.id) === this.dataset.variantId);
      this.change = () => { setTimeout(() => this.update(), 0); setTimeout(() => this.update(), 100); };
      this.host.addEventListener('click', this.change);
      this.host.addEventListener('change', this.change);
      this.observer = new MutationObserver(() => this.update());
      const options = this.host.querySelector('.product-options');
      if (options) this.observer.observe(options, { subtree: true, attributes: true, attributeFilter: ['class', 'value'] });
      this.form.addEventListener('submit', e => this.submit(e));
      this.form.addEventListener('input', () => {
        if (this.dataset.state === 'success') this.clearFeedback();
      });
      this.update(true);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.host?.removeEventListener('click', this.change);
      this.host?.removeEventListener('change', this.change);
    }
    clearFeedback() {
      this.dataset.state = '';
      this.message.textContent = '';
      this.button.disabled = false;
      this.button.textContent = this.buttonLabel;
      this.form.removeAttribute('aria-busy');
      if (this.summary) this.summary.textContent = this.summaryLabel;
    }
    update(initial = false) {
      const groups = [...this.host.querySelectorAll('.product-single-option')];
      const values = groups.map(g => g.querySelector('select')?.value || g.querySelector('.option-label.active')?.dataset.value);
      let next = this.dataset.standalone === 'true' ? this.variant : groups.length ? this.product.variants.find(v => v.options.every((o, i) => o === values[i])) : this.product.variants[0];
      if (initial && this.variant) next = this.variant;
      if (this.selected !== String(next?.id)) {
        this.controller?.abort();
        this.controller = null;
        this.selected = String(next?.id);
        this.variant = next;
        this.dataset.variantId = next ? String(next.id) : '';
        this.hidden = !next || next.available;
        this.clearFeedback();
        this.querySelector('.mvh-restock-variant').textContent = next && next.title !== 'Default Title' ? next.title : '';
      }
    }
    showFeedback(state, heading, text) {
      this.dataset.state = state;
      const title = document.createElement('strong');
      title.className = 'mvh-restock-message-title';
      title.textContent = heading;
      const body = document.createElement('span');
      body.textContent = text;
      this.message.replaceChildren(title, body);
      if (this.details) this.details.open = true;
      this.message.focus({ preventScroll: true });
      this.message.scrollIntoView({ block: 'nearest', behavior: 'auto' });
    }
    async submit(event) {
      event.preventDefault();
      if (this.dataset.state === 'pending' || this.dataset.state === 'success' || !this.form.reportValidity() || !this.variant || this.variant.available) return;
      const id = String(this.variant.id);
      const data = new FormData(this.form);
      const email = String(data.get('email') || '').trim();
      const variantName = this.variant.name || (this.variant.title !== 'Default Title' ? this.variant.title : 'this product');
      this.dataset.state = 'pending';
      this.button.disabled = true;
      this.button.textContent = 'Saving your request…';
      this.form.setAttribute('aria-busy', 'true');
      this.message.textContent = 'Please wait while we save your notification request.';
      const controller = new AbortController();
      this.controller = controller;
      try {
        const response = await fetch(this.dataset.endpoint, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ variant_id: id, email: data.get('email'), consent: data.get('consent') === 'on', website: data.get('website'), theme_id: this.dataset.themeId }),
          signal: controller.signal
        });
        const result = await response.json();
        if (!response.ok || result.ok !== true) throw new Error('Request not confirmed');
        if (this.selected !== id || this.controller !== controller) return;
        // The same wording is truthful for a saved new signup or an existing signup.
        // Never infer that a new row was created from a generic { ok: true } response.
        this.showFeedback('success', "✓ You're on the waiting list!", `Your notification request for ${variantName} is confirmed for ${email}. We'll email you once when this exact variant is available. You don't need to sign up again.`);
        this.button.textContent = '✓ Signup confirmed';
        if (this.summary) this.summary.textContent = '✓ You’re on the waiting list';
      } catch (error) {
        if (error.name !== 'AbortError' && this.selected === id && this.controller === controller) {
          this.showFeedback('error', 'We couldn’t confirm your signup', 'We couldn’t verify that your request was saved. Check your connection and try again. Your email address is still in the form.');
        }
      } finally {
        if (this.selected === id && this.controller === controller) {
          this.form.removeAttribute('aria-busy');
          this.button.disabled = this.dataset.state === 'success';
          if (this.dataset.state !== 'success') this.button.textContent = this.buttonLabel;
        }
      }
    }
  }
  customElements.define('mvh-restock', Restock);
})();
